import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { SmtpConnectionRequest, SmtpConnectionResponse } from '../models/email-inbox.model';

/**
 * Conexión SMTP/IMAP propia del usuario logueado.
 *
 * Endpoints "mine": el backend resuelve usuario y tenant desde el JWT,
 * por eso no se envía businessId ni userId.
 */
@Injectable({ providedIn: 'root' })
export class SmtpConnectionApiService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}api/email-channels/mine/smtp`;

  /** 404 si el usuario aún no registró conexión. */
  getMySmtp(): Observable<SmtpConnectionResponse> {
    return this.http.get<SmtpConnectionResponse>(this.apiUrl);
  }

  /** Alta o update idempotente: si ya existía, se actualiza. */
  registerSmtp(req: SmtpConnectionRequest): Observable<SmtpConnectionResponse> {
    return this.http.post<SmtpConnectionResponse>(this.apiUrl, req);
  }

  deleteSmtp(): Observable<void> {
    return this.http.delete<void>(this.apiUrl);
  }
}
